export enum failedPaymentResolutionTypes {
  instantRefund = "instantRefund",
  noRefund = "noRefund",
  delayedRefund = "delayedRefund",
  acceptAsPartial = "acceptAsPartial",
  settleToBalance = "settleToBalance",
  // xxxxxxxx = "xxxxxxxx",
}
